import React from 'react';
import { useParams } from 'react-router-dom';
import { useGetMovieCreditsQuery } from '../../services/movieApi';

const MovieCast = () => {
  const { movieId } = useParams();
  console.log(movieId);
  const { data: castsMovie } = useGetMovieCreditsQuery({ movieId });
  console.log(castsMovie?.cast);
  return <div>MovieCast</div>;
};

export default MovieCast;
